let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h59w5")).then(() => parcelRequire('9Qtao'));